import { createRoute, redirect } from "@tanstack/react-router";

import { rootRoute } from "../platform/routes";

/** Legacy campaign URL: account entry is shared and never enrolls a first-ad flow. */
export const freeAdSignUpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/start/free/sign-up",
  staticData: { public: true },
  beforeLoad: () => { throw redirect({ to: "/sign-up", replace: true }); },
});
